<template>
  <default>
    <div class="tw-w-full">
      <bread-crumb :breadcrumbs="breadcrumbs" />

      <div v-if="client !== null">
        <div v-if="!loading">
          <div v-if="policies.length > 0">
            <v-card flat :id="`policy-${i}`" v-for="(policy, i) in policies" :key="i" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-4 md:tw-mt-8">
              <div v-if="policy.toRenew">
                <div class="tw-w-full tw-px-4 md:tw-px-8 tw-flex tw-justify-end">
                  <div class="tw-w-full md:tw-w-1/2 tw-flex tw-items-center tw-bg-orange-200 tw-text-center lg:tw-text-left tw-rounded-lg lg:tw-rounded-full tw-border-orange-800 tw-px-2 md:tw-px-6 tw-py-3 tw-flex tw-justify-between" role="alert">
                    <p class="c-blue-text tw-italic tw-text-sm md:tw-text-base"><v-icon color="secondary">mdi-volume-high</v-icon> Your Policy is due for renewal.</p>
                    <router-link :to="{ name: 'RenewPolicy', params: { policyNo: policy.policyNo, batchNo: policy.batchNo }}" class="tw-bg-orange-500 tw-px-4 tw-py-0 tw-rounded-lg lg:tw-rounded-full tw-text-xs md:tw-text-sm tw-cursor-pointer"><span class="c-white-text">RENEW POLICY</span></router-link>
                  </div>
                </div>
              </div>
              <div v-if="isInstalmentDue(policy.paymentSchedule)" class="tw-mt-3">
                <div class="tw-w-full tw-px-4 md:tw-px-8 tw-flex tw-justify-end">
                  <div class="tw-w-full md:tw-w-1/2 tw-flex tw-items-center tw-bg-orange-200 tw-text-center lg:tw-text-left tw-rounded-lg lg:tw-rounded-full tw-border-orange-500 tw-px-2 md:tw-px-6 tw-py-3 tw-flex tw-justify-between" role="alert">
                    <p class="c-blue-text tw-italic tw-text-sm md:tw-text-base"><v-icon color="secondary">mdi-volume-high</v-icon> Your Policy instalment due for payment.</p>
                    <router-link :to="{ name: 'InstalmentPayment', params: { policyNo: policy.policyNo, batchNo: policy.batchNo }}" class="tw-bg-orange-500 tw-px-4 tw-py-0 tw-rounded-lg lg:tw-rounded-full tw-text-xs md:tw-text-sm tw-cursor-pointer"><span class="c-white-text">PAY INSTALMENT</span></router-link>
                  </div>
                </div>
              </div>
              <div class="tw-w-full tw-flex tw-text-center md:tw-text-left">
                <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-flex-wrap">
                  <div class="tw-flex tw-px-2 md:tw-px-4 xl:tw-px-4 tw-items-center">
                    <v-icon color="primary" size="90" alt="car">mdi-car-outline</v-icon>
                    <div class="tw-px-2 md:tw-px-3 lg:tw-px-4">
                      <h3 class="c-navy-text c-title tw-text-base md:tw-text-xl">{{ policy.coverType.replace('Insurance','') }}
                        <br>Insurance</h3>
                      <p class="c-blue-text tw-text-sm tw-mt-2 md:tw-mt-4"> {{policy.risks[0].model }}, {{ policy.risks[0].regno.toUpperCase() }}</p>
                    </div>
                  </div>
                  <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-4 tw-mt-5 md:tw-mt-0 tw-border-l-0 tw-border-r-0 md:tw-border-l-2 md:tw-border-r-2 tw-border-gray-300">
                    <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl">Policy Number:</h3>
                    <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl">{{ policy.policyNo }}</h3>
                  </div>
                  <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0 tw-flex tw-flex-col tw-items-center">
                    <h4 class="c-gray-text tw-text-base tw-w-full"> <strong>Start Date:</strong>{{ policy.wef | formatDate }}</h4>
                    <h4 :class="['tw-text-base tw-w-full tw-mt-0 md:tw-mt-3', diffDate(policy.wet) ? 'tw-text-red-500' : 'c-blue-text']"> <strong>Renewal Date:</strong>{{ policy.wet | formatDate }}</h4>
                  </div>
                </div>
              </div>
              <div class="tw-w-full tw-flex tw-justify-end tw-mt-2 md:tw-mt-3">
                <v-btn color="primary" :id="`view-policy-${i}`" :to="{name: 'SinglePolicy', params: {policyNo: policy.policyNo}}"><span class="c-white-text">View Policy</span><v-icon color="#fff">mdi-chevron-right</v-icon></v-btn>
              </div>
            </v-card>
          </div>
          <div class="tw-w-full tw-mt-5 md:tw-mt-10" v-if="renewalDPPolicies.length > 0">
            <v-card :id="`renewalDPPolicies-${i}`" v-for="(renewalDPPolicy, i) in renewalDPPolicies" :key="i" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-4 md:tw-mt-4">
              <div class="tw-w-full tw-px-4 md:tw-px-8 tw-flex tw-justify-end">
                  <div class="tw-w-full md:tw-w-1/2 tw-flex tw-items-center tw-bg-orange-200 tw-text-center lg:tw-text-left tw-rounded-lg lg:tw-rounded-full tw-border-orange-800 tw-px-2 md:tw-px-6 tw-py-3 tw-flex tw-justify-between" role="alert">
                    <p class="c-blue-text tw-italic tw-text-sm md:tw-text-base"><v-icon color="secondary">mdi-volume-high</v-icon> Your Policy is due for renewal.</p></div></div>
            <div class="tw-w-full tw-flex tw-text-center md:tw-text-left">
              <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-flex-wrap">
                <div class="tw-flex tw-px-2 md:tw-px-10 tw-items-center">
                  <v-icon color="primary" size="80" alt="car">mdi-home-circle-outline</v-icon>
                  <div class="tw-px-2 md:tw-px-3">
                    <h3 class="c-navy-text c-title tw-text-base md:tw-text-xl">Domestic Package</h3>
                    <!-- <p class="c-navy-text tw-text-sm tw-mt-2 md:tw-mt-4">Renew Policy</p> -->
                  </div>
                </div>
                <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-6 tw-mt-5 md:tw-mt-0">
                  <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl"> <strong>Policy Number:</strong> {{ renewalDPPolicy.policyNo }}</h3>
                  <!-- <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl">{{ filterCar(quote).car.make + ' '+ filterCar(quote).car.model + ', ' + filterCar(quote).car.yearOfManufacture  }} </h3> -->
                </div>
                <div class="tw-px-0 md:tw-px-6 tw-mt-5 md:tw-mt-0 tw-flex tw-flex-col tw-items-center">
                  <h4 class="c-blue-text tw-text-sm tw-w-full"> <strong>Cover Premium:</strong> {{ renewalDPPolicy.premium }}</h4>
                </div>
              </div>
            </div>
            <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
            <v-btn block large
                       color="secondary"
                       class="my-3 "
                       :loading="loading"
                       @click="proceed(renewalDPPolicy)"
                >
                  {{ 'Renew Policy' }}
                </v-btn>
             </v-card-actions>
          </v-card>
          </div>
          <div class="tw-w-full tw-mt-5 md:tw-mt-10" v-if="DPPolicies.length > 0">
            <v-card :id="`DPPolicies-${i}`" v-for="(DPPolicy, i) in DPPolicies" :key="i" class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-4 md:tw-mt-4">
              <div class="tw-w-full tw-px-4 md:tw-px-8 tw-flex tw-justify-end">
                  </div>
            <div class="tw-w-full tw-flex tw-text-center md:tw-text-left">
              <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-flex-wrap">
                <div class="tw-flex tw-px-2 md:tw-px-10 tw-items-center">
                  <v-icon color="primary" size="80" alt="car">mdi-home-circle-outline</v-icon>
                  <div class="tw-px-2 md:tw-px-3">
                    <h3 class="c-navy-text c-title tw-text-base md:tw-text-xl">Domestic Package</h3>
                    <!-- <p class="c-navy-text tw-text-sm tw-mt-2 md:tw-mt-4">Renew Policy</p> -->
                  </div>
                </div>
                <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-6 tw-mt-5 md:tw-mt-0">
                  <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl"> <strong>Policy Number:</strong> {{ DPPolicy.policyNo }}</h3>
                  <!-- <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl">{{ filterCar(quote).car.make + ' '+ filterCar(quote).car.model + ', ' + filterCar(quote).car.yearOfManufacture  }} </h3> -->
                </div>
                <div class="tw-px-0 md:tw-px-6 tw-mt-5 md:tw-mt-0 tw-flex tw-flex-col tw-items-center">
                  <h4 class="c-blue-text tw-text-sm tw-w-full"> <strong>Batch Number:</strong> {{ DPPolicy.batchNo }}</h4>
                </div>
              </div>
            </div>
            <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
            <v-btn block large
                       color="secondary"
                       class="my-3 "
                       :loading="loading"
                       @click="toggleMe"
                >
                  {{ 'Lodge a Claim' }}
                </v-btn>
             </v-card-actions>
             <div v-if="showForm" class="tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
              <v-dialog v-model="showForm" persistent max-width="630px">
              <v-card>
                <v-card-text>
                  <div class="tw-px-2 md:tw-px-3">
                    <br>
                  <h1 class="c-gray-text c-title tw-text-base"> Kindly provide claim details</h1>
                  </div>
                  <v-container class="tw-mt-4 md:tw-mt-8">
                  <v-form v-model="isValid">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="computedDateFormatted"
                          label="Loss Date"
                          persistent-hint
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[required('Loss Date')]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="lossDate"
                        no-title
                        @input="menu = false"
                        :max="new Date().toISOString().substr(0, 10)"
                        color="primary"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="lossLocation" ref="address" id="address" label="Loss Location" type="text" :rules="[required('Loss Location')]"></v-text-field>
                  <!-- <v-text-field type="text" v-model="coordinates" :rules="[isObjectField()]" class="tw-hidden"></v-text-field> -->
                </v-col>
                <v-col cols="12" sm="12">
                  <v-text-field v-model="description" label="Description" type="text" :rules="[required('Description')]"></v-text-field>
                </v-col>
                <v-card-actions class="col-sm-4 offset-sm-4">
                  <v-btn block large
                         color="secondary"
                         class="my-3 "
                         :disabled="!isValid"
                         @click="claimDPPolicy(DPPolicy)"
                         :loading="loading">
                    Submit
                  </v-btn>
                </v-card-actions>
              </v-row>
                  </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error" text @click="close">Close</v-btn>
                </v-card-actions>
              </v-card>
              </v-dialog>
             </div>
          </v-card>
          </div>
          <div class="tw-w-full tw-mt-5 md:tw-mt-10" v-if="policies.length === 0 && renewalDPPolicies.length === 0 && DPPolicies.length === 0">
          <v-card class="tw-w-full tw-flex tw-flex-wrap tw-text-center tw-justify-center tw-py-24">
          <div class="tw-w-full tw-flex tw-justify-center">
            <v-icon size="100">mdi-file</v-icon>
          </div>
          <p class="tw-text-2xl tw-mt-10">No Policies yet !</p>
          </v-card>
          </div>
        </div>
        <div v-else class="tw-w-full tw-flex tw-justify-center">
          <v-progress-circular
              :size="80"
              color="primary1"
              indeterminate
          ></v-progress-circular>
        </div>
      </div>
        <div class="tw-w-full tw-mt-5 md:tw-mt-10" v-else>
          <v-card class="tw-w-full tw-flex tw-flex-wrap tw-text-center tw-justify-center tw-py-24">
          <div class="tw-w-full tw-flex tw-justify-center">
            <v-icon size="100">mdi-file</v-icon>
          </div>
          <p class="tw-text-2xl tw-mt-10">No Policies yet !</p>
        </v-card>
        </div>
      </div>
  </default>
</template>

<script>
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import Default from '@/components/layout/Default';
import axios from 'axios';
import moment from 'moment';
import { diffDate, isInstalmentDue } from '@/utils/time';
import validations from '@/utils/validations';
import { mapGetters } from 'vuex';

const { Loader } = require('google-maps');

const options = { version: '3.40', language: 'en', libraries: ['places'] };
const loader = new Loader(process.env.VUE_APP_GOOGLE_MAPS_API_KEY, options);

export default {
  name: 'MyPolicies',
  components: { BreadCrumb, Default },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'My Policies',
          disabled: true,
          to: { name: 'MyPolicies' },
        },
      ],
      policies: [],
      renewalDPPolicies: [],
      DPPolicies: [],
      page: 0,
      loading: true,
      showForm: false,
      ...validations,
      isValid: false,
      form: {},
      lossDate: new Date().toISOString().substr(0, 10),
      menu: false,
      lossLocation: '',
      description: '',
    };
  },
  computed: {
    client() {
      return this.$store.getters.clientData;
    },
    computedDateFormatted() {
      return this.changeFormatDate(this.lossDate);
    },
    ...mapGetters('auth', ['authenticatedUser']),
  },
  async mounted() {
    await this.getRenewalDPPolicies(`/customer/gis/policies/renewals/bymobilenumber/${this.authenticatedUser.phone_number}/bycovertype/107`);
    await this.getDPPolicies(`/customer/gis/policies/byidnumber/${this.authenticatedUser['custom:id_number']}`);
    await this.init();
  },
  updated() {
    this.init();
    const ref = this;
    this.$nextTick(() => {
      if (typeof ref.$refs.address !== 'undefined' && !this.loaded) {
        ref.locationsAutoComplete();
      }
    });
  },
  metaInfo: {
    title: 'My Policies',
  },
  methods: {
    init() {
      if (!this.$store.state.clientLoading && this.page === 0 && this.client !== null) {
        this.getPolicies(`/customer/gis/policies/client/productGroup/70?clientCode=${this.client.clientCode}&pageNumber=1&limit=10`);
      }
    },
    toggleMe() {
      this.showForm = !this.showForm;
    },
    getPolicies(url) {
      axios.get(url)
        .then((response) => {
          this.policies = response.data.object.pageItems;
          this.page += 1;
          this.loading = false;
        });
    },
    async getRenewalDPPolicies(url) {
      await axios.get(url)
        .then((response) => {
          if (response.data) {
            this.renewalDPPolicies = response.data.object;
          }
          this.loading = false;
        });
    },
    async getDPPolicies(url) {
      await axios.get(url)
        .then((response) => {
          if (response.data) {
            this.DPPolicies = response.data.object;
          }
          this.loading = false;
        });
    },
    claimDPPolicy(DPPolicy) {
      this.loading = true;
      const dpClaim = {
        batchNo: DPPolicy.batchNo,
        lossLocation: this.lossLocation,
        lossDate: this.computedDateFormatted,
        description: this.description,
        reportedDate: this.changeFormatDate(new Date().toISOString().substr(0, 10)),
      };
      axios.post('customer/gis/claims/create', { ...dpClaim }).then((response) => {
        if (response.data.object.reference) {
          this.$toast.success('Claim lodged successfully', 'Claim');
        } else {
          this.$toast.error('An error occured when lodging your claim', 'Claim');
        }
        this.loading = false;
        this.showForm = false;
      });
    },
    proceed(renewalDPPolicy) {
      this.loading = true;
      const names = this.authenticatedUser.name.split(' ');
      const dpRenewal = {
        batch_number: renewalDPPolicy.batchNo,
        policy_number: renewalDPPolicy.policyNo,
        premium: renewalDPPolicy.premium,
        first_name: names[0],
        last_name: names.length > 2 ? names[2] : names[1],
        phone_number: this.authenticatedUser.phone_number,
        email_address: this.authenticatedUser.email,
      };
      this.$store.commit('renewal/setdpRenewal', dpRenewal);
      this.$router.push({ name: 'BuyCover', query: { b: 'dp-ren', q: renewalDPPolicy.batchNo } });
    },
    changeFormatDate(date) {
      return moment(date, 'YYYY-MM-DD').format('DD-MMM-YYYY');
    },
    async locationsAutoComplete() {
      this.loaded = true;

      loader.load().then((google) => {
        const input = document.getElementById('address');
        // const bangaloreBounds = new google.maps.LatLngBounds(
        //   new google.maps.LatLng(-4.454372, 39.146086), // sw lat, ln -1.430690, 36.638567
        //   new google.maps.LatLng(-1.145544, 37.012163), // ne, lat, ln -1.145544, 37.012163
        // );
        const autocomplete = new google.maps.places.Autocomplete(input, {
          // bounds: bangaloreBounds,
          componentRestrictions: { country: 'ke' },
          strictBounds: true,
        });

        google.maps.event.addListener(autocomplete, 'place_changed', () => {
          const place = autocomplete.getPlace();
          // eslint-disable-next-line no-unused-vars
          this.coordinates = {
            latitude: place.geometry.location.lat(),
            longitude: place.geometry.location.lng(),
          };
          this.lossLocation = place.formatted_address;
        });
      });
    },
    close() {
      this.showForm = false;
    },
    diffDate,
    isInstalmentDue,
  },
  filters: {
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD').format('Do MMM YYYY');
    },
  },
};
</script>

<style scoped>
.v-application p {
   margin-bottom: 0px!important;
}
.notShown {
  visibility: hidden !important;
}
</style>
